import * as React from 'react';
import * as DateHelpers from './DateHelpers';
import NotesPopup from './NotesPopup';
import JobQuoteExtraTrolleyData from './JobQuoteExtraTrolleyModal';
import JobQuoteExtraItemModal from './JobQuoteExtraItemModal';
import JobQuoteDeliveryAddressData from './JobQuoteDeliveryAddressModal';
import JobQuoteExtraSectionData from './JobQuoteExtraSectionModal';
import NewJobPricelistFencingStockData from './NewJobPricelistFencingStock';
import { ItemOptionList, NewJobQuoteItem, NewJobQuoteItemExtra, JobQuoteExtraItemOption, FencingStock, NewJobQuoteFenceQuestions, FenceAreaOption, DeliveryAddress, JobQuoteExtraSection, AddTrolleyGreaseTrap } from './models/JobInterfaces';
import { GenericList } from './models/JobSharedInterfaces';
import { toast } from 'react-toastify';

interface NewJobPricelistItemProps {
    isJobEvent: boolean;
    jobTypeId: number;
    scheduleDateDefaultDays: number;
    schedulePickup: boolean;
    showLocation: boolean;
    showExtras: boolean;
    showCleaning: boolean;
    showBracing: boolean;
    showMaintenance: boolean;
    showTruck: boolean;
    showEpaItems: boolean;
    showAdditionalHire: boolean;
    lunchRoomExtraId: number;
    siteOfficeExtraId: number;
    customerPickup: number;
    allowAllocateToPastDate: boolean;
    jobInstalled: boolean;
    accountTypeId: number;
    truckHireRate: number;
    fenceQuestions: NewJobQuoteFenceQuestions;
    quoteItems: NewJobQuoteItem[];
    itemOptions: ItemOptionList[];
    frequencyOptions: GenericList[];
    extraItemOptions: JobQuoteExtraItemOption[];
    yesNoOptions: GenericList[];
    truckOptions: GenericList[];
    truckSideOptions: GenericList[];
    customerChargeFuelSurcharge: boolean;
    customerNewFuelInvoice: boolean;
    chargeFuelSurchargeSwitchedOn: boolean;
    addItem(quoteItem: NewJobQuoteItem, calculatePrice: boolean): void;
    deleteItem(itemIndex: number): void;
    updateQuoteItem(quoteItem: NewJobQuoteItem, calculatePrice: boolean): void;
}

interface EditNote {
    heading: string;
    rowIndex: number;
    parentIndex: number;
    id: number;
    itemId: number;
    item: string;
    notes: string;
}


const initExtraSection: JobQuoteExtraSection = {
    totalLength: 0,
    crossoverQuantity: 0,
    sectionQuantity: 0,
    totalCrossoverLength: "0.0"
}

const NewJobPricelistToiletData = (props: NewJobPricelistItemProps) => {
    const [showEditNotesModal, setShowEditNotesModal] = React.useState(false);
    const [editNote, setEditNote] = React.useState<EditNote>({
        heading: "",
        id: 0,
        item: "",
        itemId: -1,
        notes: "",
        parentIndex: -1,
        rowIndex: -1
    });
    const [showExtraTrolley, setShowExtraTrolley] = React.useState(false);
    const [extraTrolley, setExtraTrolley] = React.useState<AddTrolleyGreaseTrap>({ trolley: false, isEpa: false});
    const [showExtraItems, setShowExtraItems] = React.useState(false);
    const [extras, setExtras] = React.useState<NewJobQuoteItemExtra>({
        itemId: -1,
        quantity: 0,
        equipped: false
    });
    const [showFencingStock, setShowFencingStock] = React.useState(false);
    const [fencingStock, setFencingStock] = React.useState<FencingStock>({
        panels: 0,
        blocks: 0,
        clamps: 0,
        pickets: 0,
        signs: 0,
        braces: 0
    });
    const [itemDescription, setItemDescription] = React.useState("");
    const [tableChairs, setTableChairs] = React.useState({ tables: 1, chairs: 2 });
    const [showDelAddress, setShowDelAddress] = React.useState(false);
    const [deliveryAddress, setDeliveryAddress] = React.useState<DeliveryAddress>({
        deliveryAddress: "",
        deliveryAddressGooglePlaceId: "",
        deliveryAddressLatitude: 0,
        deliveryAddressLongitude: 0
    });
    const [showInvDesc, setShowInvDesc] = React.useState(false);
    const [invoiceDescription, setInvoiceDescription] = React.useState("");
    const [showExtraSection, setShowExtraSection] = React.useState(false);
    const [extraSection, setExtraSection] = React.useState<JobQuoteExtraSection>(initExtraSection);
    const [itemIndex, setItemIndex] = React.useState(-1);

    const handleCellChange = (e: any, jobIndex: number) => {
        let quoteItems = props.quoteItems;
        let item = quoteItems[jobIndex];

        let quoteItem: any = {};
        quoteItem = item;
        var value = e.target.value * 1;
        quoteItem[e.target.name] = value;

        if (jobIndex === (quoteItems.length - 1)) {
            var newItem = addBlankQuoteItem();
            props.addItem(newItem, false);
        }

        if (e.target.name === "overhireRate" || e.target.name === "truckDoors" || item.itemTypeId === 61) {
            //don't calculate price when updating amount / travel / overhire rate or EPA Other items
            props.updateQuoteItem(quoteItem, false);
        } else {
            //calculate price
            props.updateQuoteItem(quoteItem, true);
        }
    }

    const handleCellHoursChange = (e: any, jobIndex: number) => {
        let quoteItems = props.quoteItems;
        let item = quoteItems[jobIndex];

        let quoteItem: any = {};
        quoteItem = item;
        var value = e.target.value * 1;
        quoteItem[e.target.name] = value;

        if (jobIndex === (quoteItems.length - 1)) {
            var newItem = addBlankQuoteItem();
            props.addItem(newItem, false);
        }

        if (item.itemTypeId === 61) {
            //don't calculate price when hours for EPA Other jobs as we don't use the pricelist
            var truckHours = value < 3 ? 3 : value;     //minimum rate is for 3 hours
            quoteItem.trench = truckHours * props.truckHireRate;
            quoteItem.amount = item.initialHire + item.trench + item.confinedSpace + item.cleaning + item.travel + item.fuelSurcharge;

            props.updateQuoteItem(quoteItem, false);
        } else {
            //calculate price
            props.updateQuoteItem(quoteItem, true);
        }
    }

    const handleItemChange = (e: any, jobIndex: number) => {
        let quoteItems = props.quoteItems;
        let item = quoteItems[jobIndex];

        let quoteItem: any = {};
        quoteItem = item;
        var value = e.target.value * 1;
        quoteItem[e.target.name] = value;

        if (props.showBracing) {
            //update qty to 0 and reset totals for fencing 
            item.quantity = 0;      //setting this to 0 as otherwise it's too easy not to update the qty
            item.initialHire = 0;
            item.travel = 0;
            item.cleaning = 0;
            item.hours = 0;
            item.trench = 0;
            item.amount = 0;
            item.overhireRate = "0.00";
        } else {
            item.quantity = 1;
        }
        item.customHirePeriod = false;

        item = addItemDetails(item, value);

        if (jobIndex === (quoteItems.length - 1)) {
            var newItem = addBlankQuoteItem();
            props.addItem(newItem, false);
        }

        var calcPrice = item.quantity === 0 || item.itemTypeId === 61 ? false : true;
        props.updateQuoteItem(quoteItem, calcPrice);
    }

    const addItemDetails = (item: NewJobQuoteItem, itemId: number) => {
        var itemOption = props.itemOptions.find(i => i.id === itemId);
        if (itemOption) {
            if (itemOption.typeId === 26 || itemOption.typeId === 44 || itemOption.typeId === 45 || itemOption.typeId === 47 || (itemOption.typeId >= 58 && itemOption.typeId <= 61)) {
                item.hirePeriod = 1;    //pump and cleans are set to 1 day as it is a one off charge each time
            } else if (itemOption.typeId === 8 || itemOption.typeId === 22 || (itemOption.typeId >= 50 && itemOption.typeId <= 54)) {
                item.hirePeriod = itemOption.priceListDefaultDays;
            } else {
                item.hirePeriod = -1;
            }

            item.defaultHirePeriod = itemOption.priceListDefaultDays;
            item.installOnly = itemOption.installOnly;
            item.truck = itemOption.defaultTruckId;
            item.isEws = itemOption.isEws;
            item.isWaste = itemOption.typeId === 21;
            item.itemTypeId = itemOption.typeId;
            item.item = itemOption.name;
            item.itemDescription = itemOption.description;
            item.frequencyId = -1;
            item.locationId = -1;
            //clear any extras as other items don't have extras
            item.extras.itemId = -1;
            item.extras.quantity = 0;
            item.fenceBraceId = -1;
            item.extendable = itemOption.extendable;
            item.unitOfMeasure = itemOption.unitOfMeasure;
            item.invoicePeriodTypeId = itemOption.invoicePeriodTypeId;
            item.productGroupId = itemOption.productGroupId;
            item.onHireDate = "";
            item.offhireDate = "";
            item.scheduleDate = "";
            item.pickupDate = "";

            if (item.itemTypeId === 29) {
                //showers automatically get a trolley added
                item.trolley = true;
            } else {
                item.trolley = false;
            }

            //set equipment for lunchroom as it is included in the hire price
            if (item.itemTypeId === 17) {
                item.extras.equipped = true;
            } else {
                item.extras.equipped = false;
            }

            //make sure the extras are updated per item type
            if (item.itemTypeId === 14 && item.extras.quantity > 0) {
                item.extras.itemId = props.siteOfficeExtraId;
            } else if (item.itemTypeId === 17 && item.extras.quantity > 0) {
                item.extras.itemId = props.lunchRoomExtraId;
            } else {
                //clear any extras as item id has changed to an item with no extras
                item.extras.itemId = -1;
                item.extras.quantity = 0;
            }

            //Septics, Grease Traps and Waste Tank default sizes
            if (item.itemTypeId === 58) {
                item.size = itemOption.name.includes("Treatment Plant") ? 7000 : 3200;
            } else if (item.itemTypeId === 59) {
                item.size = 1000;
            } else if (item.itemTypeId === 60) {
                item.size = 4000;
            } else {
                item.size = 0;
            }

            if (item.itemTypeId === 61) {
                item.hours = 3;
                item.trench = 3 * props.truckHireRate;
                var amt = item.initialHire + item.trench + item.confinedSpace + item.cleaning + item.travel + item.fuelSurcharge;
                item.amount = parseFloat(amt.toFixed(2));
            } else if (item.itemTypeId > 57 && item.itemTypeId < 61) {
                //clear hours and trench for other EPA items
                item.hours = 0;
                item.trench = 0;
            }

            //add PO note for fencing items and PO customers
            if (props.accountTypeId === 3 && (item.itemTypeId === 8 || item.itemTypeId === 50 || item.itemTypeId === 51 || item.itemTypeId === 53)) {
                item.notes = "Do not go over quoted lm without getting a new PO number";
            } 
        }

        return item;
    }


    const handleCellAmountChange = (e: any, jobIndex: number) => {
        let quoteItems = props.quoteItems;
        let item = quoteItems[jobIndex];
        item.amount = e.target.value;

        //calculate initial hire
        item.initialHire = (e.target.value * 1) - item.travel - item.fuelSurcharge;

        if (jobIndex === (quoteItems.length - 1)) {
            var newItem = addBlankQuoteItem();
            props.addItem(newItem, false);
        }

        //don't calculate price when updating amount
        props.updateQuoteItem(item, false);
    }

    const handleCellPriceChange = (e: any, jobIndex: number) => {
        let quoteItems = props.quoteItems;
        let item = quoteItems[jobIndex];

        let quoteItem: any = {};
        quoteItem = item;
        var value = e.target.value * 1;
        quoteItem[e.target.name] = value;

        //calculate amount
        var amt = item.initialHire + item.trench + item.confinedSpace + item.cleaning + item.travel + item.fuelSurcharge;
        item.amount = parseFloat(amt.toFixed(2));

        if (jobIndex === (quoteItems.length - 1)) {
            var newItem = addBlankQuoteItem();
            props.addItem(newItem, false);
        }

        //don't calculate price when updating initial hire / travel
        props.updateQuoteItem(quoteItem, false);
    }

    const handleCellChangeText = (e: any, jobIndex: number) => {
        let quoteItems = props.quoteItems;
        let item = quoteItems[jobIndex];

        let quoteItem: any = {};
        quoteItem = item;
        var value = e.target.value;
        quoteItem[e.target.name] = value;

        if (jobIndex === (quoteItems.length - 1)) {
            var newItem = addBlankQuoteItem();
            props.addItem(newItem, false);
        }

        props.updateQuoteItem(item, false);
    }

    const handleScheduleDateChange = (e: any, jobIndex: number) => {
        let quoteItems = props.quoteItems;
        let item = quoteItems[jobIndex];

        let quoteItem: any = {};
        quoteItem = item;
        var value = e.target.value;
        quoteItem[e.target.name] = value;
        quoteItem["onHireDate"] = value;
        //if they are scheduling a Toilet Pickup / with P&C we need to set the offhire date as won't create an install
        if (item.itemTypeId === 45) {
            quoteItem["offHireDate"] = value;
            quoteItem["pickupDate"] = value;
        }

        if (jobIndex === (quoteItems.length - 1)) {
            var newItem = addBlankQuoteItem();
            props.addItem(newItem, false);
        }

        props.updateQuoteItem(item, false);
    }

    const handleCellDateChange = (e: any, jobIndex: number) => {
        let quoteItems = props.quoteItems;
        let item = quoteItems[jobIndex];

        let quoteItem: any = {};
        quoteItem = item;
        var value = e.target.value;
        quoteItem[e.target.name] = value;

        if (jobIndex === (quoteItems.length - 1)) {
            var newItem = addBlankQuoteItem();
            props.addItem(newItem, false);
        }

        props.updateQuoteItem(item, false);
    }

    const handleBraceChange = (e: any, jobIndex: number) => {
        let quoteItems = [...props.quoteItems];
        let quoteItem = quoteItems[jobIndex];

        if (props.fenceQuestions.fenceTotalMetres > 0) {
            var value = e.target.value * 1;
            quoteItem.fenceBraceId = value;

            var braceQty = calculateBraceQty(value)
            quoteItem.quantity = braceQty;

            if (jobIndex === (quoteItems.length - 1)) {
                var newItem = addBlankQuoteItem();
                props.addItem(newItem, false);
            }

            props.updateQuoteItem(quoteItem, true);
        } else {
            //props.addError("fenceTotalMetres", "Enter total metres of fencing required!");
            toast.error("Enter the Total # Metres before selecting bracing!");
        }
    }

    const calculateBraceQty = (fenceBraceId: number) => {
        var qty = 0;
        //if custom we just want to add the signage panels not do a calc using total metres
        if (fenceBraceId < 4) {
            //calculate # braces required
            qty = (props.fenceQuestions.fenceTotalMetres / 2.4) / fenceBraceId;
        }
        //add on extra panels with signs
        qty += props.fenceQuestions.signagePanels;

        let braceQty = Math.trunc(qty);

        return braceQty;
    }

    const addBlankQuoteItem = () => {
        var item: NewJobQuoteItem = {
            itemIndex: -1,
            itemId: -1,
            item: "",
            itemTypeId: -1,
            productGroupId: 0,
            itemDescription: "",
            installOnly: false,
            extendable: true,
            isEws: false,
            isWaste: false,
            isUnderground: false,
            isEvent: false,
            unitNumber: "",
            scheduleDate: "",
            onHireDate: "",
            offhireDate: "",
            pickupDate: "",
            hirePeriod: -1,
            defaultHirePeriod: 42,
            customHirePeriod: false,
            frequencyId: -1,
            locationId: -1,
            fenceBraceId: -1,
            hours: 0,
            size: 0,
            quantity: 1,
            unitOfMeasure: "",
            initialHire: 0,
            travel: 0,
            cleaning: 0,
            trench: 0,
            confinedSpace: 0,
            fuelSurcharge: 0,
            amount: 0,
            overhireRate: "0.00",
            truck: 0,
            truckDoors: -1,
            purchaseOrderNumber: "",
            purchaseOrderNumberFuel: "",
            notes: "",
            trolley: false,
            extras: {
                itemId: -1,
                quantity: 0,
                equipped: false
            },
            fencingStock: {
                panels: 0,
                blocks: 0,
                clamps: 0,
                pickets: 0,
                signs: 0,
                braces: 0
            },
            calculatedPriceNote: "",
            deliveryAddress: "",
            deliveryAddressGooglePlaceId: "",
            deliveryAddressLatitude: 0,
            deliveryAddressLongitude: 0,
            invoiceDescription: "",
            incStepsTravel: false,
            invoicePeriodTypeId: 1
        };

        return item;
    }

    //NOTES
    const editNotes = (e: any, jobIndex: number) => {
        e.preventDefault();

        let quoteItems = props.quoteItems;
        let item = quoteItems[jobIndex];

        var note: EditNote = {
            heading: "Item Notes",
            parentIndex: 0,
            rowIndex: jobIndex,
            id: 0,
            itemId: item.itemId,
            item: "",
            notes: item.notes
        };

        setEditNote(note);
        setShowEditNotesModal(true);
    }

    const hideNotes = () => {
        let note = resetNotes();
        setEditNote(note);
        setShowEditNotesModal(false);
    }

    const updateNotes = (note: EditNote) => {
        setEditNote(prevState => ({ ...prevState, note }));
    }

    const resetNotes = () => {
        //reset
        var note: EditNote = {
            heading: "",
            parentIndex: 0,
            rowIndex: 0,
            id: 0,
            itemId: 0,
            item: "",
            notes: ""
        };

        return note;
    }

    const saveNotes = () => {
        let quoteItems = props.quoteItems;
        let item = quoteItems[editNote.rowIndex];

        item.notes = editNote.notes;

        let note = resetNotes();

        setEditNote(note);
        setShowEditNotesModal(false);
        props.updateQuoteItem(item, false);
    }
    //END NOTES

    //EXTRA ITEMS
    const addExtraItems = (e: any, jobIndex: number) => {
        e.preventDefault();

        let quoteItem = props.quoteItems[jobIndex];
        let extras: NewJobQuoteItemExtra =
        {
            itemId: quoteItem.itemTypeId === 14 ? props.siteOfficeExtraId : quoteItem.itemTypeId === 17 ? props.lunchRoomExtraId : 0,
            equipped: quoteItem.itemTypeId === 17,      //lunchrooms have equipment
            quantity: quoteItem.extras.quantity
        };

        //quoteItem.extras;
        let isItemLarge = quoteItem.item.includes("6.0");
        let noChairs = quoteItem.itemTypeId === 14 && isItemLarge ? 4 : quoteItem.itemTypeId === 17 && isItemLarge ? 8 : quoteItem.itemTypeId === 17 ? 4 : 2;

        setItemIndex(jobIndex);
        setItemDescription(quoteItem.itemDescription);
        setTableChairs({ tables: isItemLarge ? 2 : 1, chairs: noChairs });
        setExtras(extras);
        var delAddr: DeliveryAddress = {
            deliveryAddress: quoteItem.deliveryAddress,
            deliveryAddressGooglePlaceId: quoteItem.deliveryAddressGooglePlaceId,
            deliveryAddressLatitude: quoteItem.deliveryAddressLatitude,
            deliveryAddressLongitude: quoteItem.deliveryAddressLongitude
        };
        setDeliveryAddress(delAddr);
        setShowExtraItems(true);
    }

    const hideExtraItems = () => {
        var extra: NewJobQuoteItemExtra = {
            itemId: -1,
            quantity: 0,
            equipped: false
        };
        setItemIndex(-1);
        setItemDescription("");
        setTableChairs({ tables: 1, chairs: 2 });
        setExtras(extra);
        setShowExtraItems(false);
    }

    const updateExtraItems = (extraItem: NewJobQuoteItemExtra) => {
        setExtras(prevState => ({ ...prevState, extraItem }));
    }

    const saveExtraItems = (deliveryAddress: DeliveryAddress) => {
        let quoteItems = props.quoteItems;
        let quoteItem = quoteItems[itemIndex];

        quoteItem.extras = extras;
        var extra: NewJobQuoteItemExtra = {
            itemId: -1,
            quantity: 0,
            equipped: false
        };

        if (deliveryAddress && deliveryAddress.deliveryAddress != "") {
            quoteItem.deliveryAddress = deliveryAddress.deliveryAddress;
            quoteItem.deliveryAddressGooglePlaceId = deliveryAddress.deliveryAddressGooglePlaceId;
            quoteItem.deliveryAddressLatitude = deliveryAddress.deliveryAddressLatitude;
            quoteItem.deliveryAddressLongitude = deliveryAddress.deliveryAddressLongitude;
        }

        setItemIndex(-1);
        setItemDescription("");
        setTableChairs({ tables: 1, chairs: 2 });
        setExtras(extra);
        setShowExtraItems(false);
        props.updateQuoteItem(quoteItem, true);
    }
    //END EXTRA ITEMS

    //DELIVERY ADDRESS
    const editDelAddress = (e: any, jobIndex: number) => {
        e.preventDefault();

        let quoteItems = props.quoteItems;
        let item = quoteItems[jobIndex];

        setItemIndex(jobIndex);
        var delAddr: DeliveryAddress = {
            deliveryAddress: item.deliveryAddress,
            deliveryAddressGooglePlaceId: item.deliveryAddressGooglePlaceId,
            deliveryAddressLatitude: item.deliveryAddressLatitude,
            deliveryAddressLongitude: item.deliveryAddressLongitude
        };
        setDeliveryAddress(delAddr);
        setShowDelAddress(true);
    }

    const hideDelAddress = () => {
        setShowDelAddress(false);
        var delAddr = resetDeliveryAddress();
        setDeliveryAddress(delAddr);
        setItemIndex(-1);
        setShowInvDesc(false);
        setInvoiceDescription("");
    }

    const updateDelAddress = (updatedDeliveryAddress: DeliveryAddress) => {
        setDeliveryAddress(updatedDeliveryAddress);
    }

    const clearDelAddress = () => {
        var delAddress = resetDeliveryAddress();
        setDeliveryAddress(delAddress);
    }

    const resetDeliveryAddress = () => {
        var delAddr: DeliveryAddress = {
            deliveryAddress: "",
            deliveryAddressGooglePlaceId: "",
            deliveryAddressLatitude: 0,
            deliveryAddressLongitude: 0
        };
        return delAddr;
    }

    const saveDelAddress = () => {
        let quoteItems = props.quoteItems;
        let item = quoteItems[itemIndex];

        if (deliveryAddress.deliveryAddress != "") {
            item.deliveryAddress = deliveryAddress.deliveryAddress;
            item.deliveryAddressGooglePlaceId = deliveryAddress.deliveryAddressGooglePlaceId;
            item.deliveryAddressLatitude = deliveryAddress.deliveryAddressLatitude;
            item.deliveryAddressLongitude = deliveryAddress.deliveryAddressLongitude;
        }
        item.invoiceDescription = invoiceDescription;

        setItemIndex(-1);
        var delAddress = resetDeliveryAddress();
        setDeliveryAddress(delAddress);
        setShowDelAddress(false);
        setShowInvDesc(false);
        setInvoiceDescription("");
        props.updateQuoteItem(item, false);
    }
    //END DELIVERY ADDRESS

    //INVOICE DESCRIPTION
    const editInvoiceDescription = (e: any, jobIndex: number) => {
        e.preventDefault();

        let quoteItems = props.quoteItems;
        let item = quoteItems[jobIndex];

        setItemIndex(jobIndex);
        setInvoiceDescription(item.invoiceDescription);
        setShowInvDesc(true);
    }

    const updateInvDesc = (updatedInvoiceDescription: string) => {
        setInvoiceDescription(updatedInvoiceDescription);
    }
    //END INVOICE DESCRIPTION

    //TROLLEY - add trolley to the job
    const viewTrolley = (e: any, jobIndex: number) => {
        e.preventDefault();

        let quoteItems = props.quoteItems;
        let item = quoteItems[jobIndex];

        setItemIndex(jobIndex);
        setExtraTrolley({ trolley: item.trolley, isEpa: item.productGroupId === 6 });
        setShowExtraTrolley(true);
    }

    const updateExtraTrolley = (trolley: boolean) => {
        setExtraTrolley(prevState => ({ ...prevState, trolley: trolley }));
    }

    const hideExtraTrolley = () => {
        setItemIndex(-1);
        setExtraTrolley({ trolley: false, isEpa: false });
        setShowExtraTrolley(false);
    }

    const saveExtraTrolley = () => {
        let quoteItems = props.quoteItems;
        let item = quoteItems[itemIndex];
        item.trolley = extraTrolley.trolley;

        setItemIndex(-1);
        setExtraTrolley({ trolley: false, isEpa: false });
        setShowExtraTrolley(false);

        props.updateQuoteItem(item, true);
    }
    //END TROLLEY

    //EXTRA CROSSOVER SECTIONS
    const calculateCrossoverQuantity = (e: any, jobIndex: number) => {
        e.preventDefault();
        let quoteItems = props.quoteItems;
        let quoteItem = quoteItems[jobIndex];
        var quoteItemExtra = quoteItem.extras;

        //calculate total length
        var extraQty = quoteItemExtra ? quoteItemExtra.quantity : 0;
        var totalCrossoverLength = (quoteItem.quantity * 4.8) + (extraQty * 0.3);

        var extraCrossoverSection: JobQuoteExtraSection = {
            totalLength: totalCrossoverLength,
            crossoverQuantity: quoteItem.quantity,
            sectionQuantity: extraQty,
            totalCrossoverLength: totalCrossoverLength.toFixed(1)
        };

        setShowExtraSection(true);
        setItemIndex(jobIndex);
        setExtraSection(extraCrossoverSection);
    }

    const updateExtraSection = (extraCrossoverSection: JobQuoteExtraSection) => {
        var totalCrossoverLength = (extraCrossoverSection.crossoverQuantity * 4.8) + (extraCrossoverSection.sectionQuantity * 0.3);
        extraCrossoverSection.totalCrossoverLength = totalCrossoverLength.toFixed(1);

        setExtraSection(extraCrossoverSection);
    }

    const hideExtraSection = () => {
        var extraCrossoverSection: JobQuoteExtraSection = {
            totalLength: 0,
            crossoverQuantity: 0,
            sectionQuantity: 0,
            totalCrossoverLength: "0.0"
        };

        setShowExtraSection(false);
        setItemIndex(-1);
        setExtraSection(extraCrossoverSection);
    }

    const saveCrossoverTotal = () => {
        let quoteItems = props.quoteItems;
        let quoteItem = quoteItems[itemIndex];

        //update quote
        quoteItem.extras.itemId = quoteItem.itemId;
        quoteItem.extras.quantity = extraSection.sectionQuantity;
        quoteItem.quantity = extraSection.crossoverQuantity;

        //reset
        var extraCrossoverSection: JobQuoteExtraSection = {
            totalLength: 0,
            crossoverQuantity: 0,
            sectionQuantity: 0,
            totalCrossoverLength: "0.0"
        };

        setShowExtraSection(false);
        setItemIndex(-1);
        setExtraSection(extraCrossoverSection);

        props.updateQuoteItem(quoteItem, true);
    }
    //END EXTRA CROSSOVER SECTIONS

    //FENCING STOCK
    const openFencingStock = (e: any, jobIndex: number) => {
        e.preventDefault();

        var quoteItem = props.quoteItems[jobIndex];

        setItemIndex(jobIndex);
        setFencingStock(prevState => ({ ...prevState, panels: quoteItem.fencingStock.panels, blocks: quoteItem.fencingStock.blocks, clamps: quoteItem.fencingStock.clamps, pickets: quoteItem.fencingStock.pickets, signs: quoteItem.fencingStock.signs, braces: quoteItem.fencingStock.braces }));
        setShowFencingStock(true);
    }

    const updateFencingStock = (updatedFencingStock: FencingStock) => {
        setFencingStock(prevState => ({
            ...prevState, updatedFencingStock
        }));
    }

    const hideFencingStock = () => {
        setFencingStock(prevState => ({ ...prevState, panels: 0, blocks: 0, clamps: 0, pickets: 0, signs: 0, braces: 0 }));
        setItemIndex(-1);
        setShowFencingStock(false);
    }

    const saveFencingStock = () => {
        //save the stock to the job
        let quoteItems = props.quoteItems;
        let quoteItem = quoteItems[itemIndex];

        var stock: FencingStock = {
            panels: fencingStock.panels,
            blocks: fencingStock.blocks,
            clamps: fencingStock.clamps,
            pickets: fencingStock.pickets,
            signs: fencingStock.signs,
            braces: fencingStock.braces
        };

        quoteItem.fencingStock = stock;

        setFencingStock(prevState => ({ ...prevState, panels: 0, blocks: 0, clamps: 0, pickets: 0, signs: 0, braces: 0 }));
        setItemIndex(-1);
        setShowFencingStock(false);
        props.updateQuoteItem(quoteItem, false);
    }
    //END FENCING STOCK

    //Enter custom hire period
    const editCustomHirePeriod = (e: any, jobIndex: number) => {
        e.preventDefault();

        let quoteItems = props.quoteItems;
        let item = quoteItems[jobIndex];
        item.customHirePeriod = true;
        item.hirePeriod = item.hirePeriod <= 0 ? 1 : item.invoicePeriodTypeId === 2 ? item.hirePeriod : item.hirePeriod / 7;
        props.updateQuoteItem(item, false);
    }
    //END Custom Hire Period

    const deleteItem = (e: any, jobIndex: number) => {
        e.preventDefault();
        props.deleteItem(jobIndex);
    }

    const notesPopup = <NotesPopup showEditNotesModal={showEditNotesModal} editNotes={editNote} hideNotes={hideNotes} updateNotes={updateNotes} saveNotes={saveNotes} />
    const extrasPopup = <JobQuoteExtraItemModal isEvent={props.isJobEvent} existDeliveryAddress={deliveryAddress.deliveryAddress} showModal={showExtraItems} extraItemOptions={props.extraItemOptions} itemDescription={itemDescription} itemTableDesk={tableChairs.tables} itemChairs={tableChairs.chairs} readonly={false} extras={extras} hideModal={hideExtraItems} update={updateExtraItems} save={saveExtraItems} />
    const extraSections = <JobQuoteExtraSectionData showModal={showExtraSection} crossoverTotal={extraSection} readOnly={false} update={updateExtraSection} hideModal={hideExtraSection} saveModal={saveCrossoverTotal} />
    const fencingStockPopup = <NewJobPricelistFencingStockData showModal={showFencingStock} fencingStock={fencingStock} update={updateFencingStock} hideModal={hideFencingStock} saveModal={saveFencingStock} />
    const delAddressPopup = <JobQuoteDeliveryAddressData deliveryAddress={deliveryAddress} showDeliveryAddress={showDelAddress} invoiceDescription={invoiceDescription} showInvoiceDescription={showInvDesc} trolleyRequired={false} showTrolley={false} readOnly={false} showModal={showDelAddress || showInvDesc} hideModal={hideDelAddress} updateDeliveryAddress={updateDelAddress} clearDeliveryAddress={clearDelAddress} updateInvoiceDescription={updateInvDesc} updateTrolley={updateExtraTrolley} saveModal={saveDelAddress} />
    let extraTrolleyPopup = <JobQuoteExtraTrolleyData showModal={showExtraTrolley} readOnly={false} trolley={extraTrolley.trolley} isEpa={extraTrolley.isEpa} update={updateExtraTrolley} hideModal={hideExtraTrolley} saveModal={saveExtraTrolley} />
    const lastRowIndex = props.quoteItems.length - 1;
    const minDate = props.jobInstalled ? DateHelpers.addDaysToCurrentDate(-1500) : props.allowAllocateToPastDate ? DateHelpers.addDaysToCurrentDate(-90) : DateHelpers.addDaysToCurrentDate(-2);

    return (
        <div>
            <div className="static-modal">
                {notesPopup}
                {extraTrolleyPopup}
                {extrasPopup}
                {delAddressPopup}
                {extraSections}
                {fencingStockPopup}
            </div>
            <div className="overflowAuto">
                <table className="table tableColours">
                    <thead>
                        <tr>
                            <th></th>
                            <th>Item</th>
                            <th className={props.showLocation ? "" : "hidden"}>Loc.</th>
                            <th className={props.showExtras ? "" : "hidden"}>Extra</th>
                            <th className={props.showBracing ? "" : "hidden"}>Bracing</th>
                            <th className={props.jobTypeId === 3 || props.showEpaItems ? "hidden" : ""}>Unit #</th>
                            <th className={props.showTruck ? "" : "hidden" }>Truck</th>
                            <th className={props.jobTypeId === 3 || !props.showTruck ? "hidden" : ""}>
                                <div className="tooltipitem tooltipitem__right">Doors Facing?
                                    <span className="tooltipitemtext tooltipitemtext__right">Which way are the doors to face? (remembering the tilt slide reverses into position)</span>
                                </div>
                            </th>
                            <th className={props.jobTypeId === 3 ? "hidden" : ""}>Delivery Date</th>
                            <th className={props.jobTypeId === 3 || (!props.isJobEvent && !props.schedulePickup) ? "hidden" : ""}>Pickup Date</th>
                            <th>Hire Period</th>
                            <th></th>
                            <th className={props.showMaintenance ? "" : "hidden"}>Maintenance</th>
                            <th className={props.showEpaItems ? "" : "hidden"}>Size (litres)</th>
                            <th className={props.showEpaItems ? "" : "hidden"}>Hours</th>
                            <th>Quantity</th>
                            <th>UOM</th>
                            <th className={props.jobTypeId === 3 ? "hidden" : ""}>PO #</th>
                            <th className={props.jobTypeId === 3 || !props.chargeFuelSurchargeSwitchedOn || !props.customerNewFuelInvoice ? "hidden" : ""}>PO FUEL #</th>
                            <th>{props.showEpaItems ? "Service Amt" : "Initial Hire"}</th>
                            <th className={props.showEpaItems ? "" : "hidden"}>Truck Hire</th>
                            <th className={props.showEpaItems ? "" : "hidden"}>Confined Space</th>
                            <th className={props.showCleaning ? "" : "hidden"}>{props.showEpaItems ? "Callout" : "Cleaning"}</th>
                            <th>Travel</th>
                            <th>Fuel</th>
                            <th>Total Amount</th>
                            <th className={props.showAdditionalHire ? "" : "hidden"}>Add. Hire Rate</th>
                            <th>Notes</th>
                            <th></th>
                        </tr>
                    </thead>
                    {props.quoteItems.map((item, index) =>
                        <tbody key={index}>
                            <tr key={index}>
                                <td className="table__text--align">{index + 1}</td>
                                <td className="table__text--align">
                                    <select className="select table__select--size newJobPricelist-item--size" id="itemId" name="itemId" value={item.itemId} onChange={(e) => handleItemChange(e, index)}>
                                        <option hidden defaultValue="-1"></option>
                                        {props.itemOptions.map(item =>
                                            <option key={item.id} value={item.id}> {item.name}</option> 
                                        )};
                                    </select>
                                </td>
                                <td className={props.showLocation ? "table__text--align": "hidden"}>
                                    <select className={item.itemId === 81 ? "select" : "hidden"} id="locationId" name="locationId" value={item.locationId} onChange={(e) => handleCellChange(e, index)}>
                                        <option defaultValue="-1"></option>
                                        <option key={1} value={1}>In Yard</option>
                                        <option key={2} value={2}>On Site</option>
                                    </select>
                                </td>
                                <td className={props.showExtras ? "table__text--align" : "hidden"}>
                                    <a className={lastRowIndex != index && (item.itemTypeId === 14 || item.itemTypeId === 17) ? "" : "hidden"} href="#" onClick={(e) => addExtraItems(e, index)}>
                                        <span className={"fa-solid fa-circle-plus edit--icon alignIconCenter tooltipitem tooltipitem__right" + (item.extras.quantity > 0 || item.extras.equipped ? " makeitgreen" : "")}><span className="tooltipitemtext tooltipitemtext__right">Add Equipment and/or extra Table/Desk and Chairs</span></span>
                                    </a>
                                    <a className={!props.isJobEvent || item.itemId < 1 || item.itemTypeId === 14 || item.itemTypeId === 17 ? "hidden" : ""} href="#" onClick={(e) => editDelAddress(e, index)}>
                                        <span className={"fa-solid fa-circle-plus edit--icon alignIconCenter tooltipitem tooltipitem__right" + (item.deliveryAddress === "" ? "" : " makeitgreen")}><span className="tooltipitemtext tooltipitemtext__right">Add a different delivery address</span></span>
                                    </a>
                                    <a className={item.itemTypeId === 25 || item.itemTypeId === 44 || item.itemTypeId === 45 ? "" : "hidden"} href="#" onClick={(e) => viewTrolley(e, index)}>
                                        <span className={"fa-solid fa-circle-plus edit--icon alignIconCenter tooltipitem tooltipitem__right" + (item.trolley ? " makeitgreen" : "")}><span className="tooltipitemtext tooltipitemtext__right">Add a trolley to the job</span></span>
                                    </a>
                                    <a className={item.itemTypeId === 58 ? "" : "hidden"} href="#" onClick={(e) => viewTrolley(e, index)}>
                                        <span className={"fa-solid fa-circle-plus edit--icon alignIconCenter tooltipitem tooltipitem__right" + (item.trolley ? " makeitgreen" : "")}><span className="tooltipitemtext tooltipitemtext__right">Add a domestic grease trap to the job</span></span>
                                    </a>
                                    <a className={item.itemTypeId === 27 ? "" : "hidden"} href="#" onClick={(e) => calculateCrossoverQuantity(e, index)}>
                                        <span className={"fa-solid fa-circle-plus edit--icon alignIconCenter tooltipitem tooltipitem__right" + (item.extras.quantity > 0 ? " makeitgreen" : "")}><span className="tooltipitemtext tooltipitemtext__right">Calculate Crossover Sections</span></span>
                                    </a>
                                    <a className={item.itemTypeId === 22 || item.itemTypeId === 52 || item.itemTypeId === 61 ? "" : "hidden"} href="#" onClick={(e) => editInvoiceDescription(e, index)}>
                                        <span className={"fa-solid fa-circle-plus edit--icon alignIconCenter tooltipitem tooltipitem__right" + (item.invoiceDescription === "" ? "" : " makeitgreen")}><span className="tooltipitemtext tooltipitemtext__right">Add a description for the invoice</span></span>
                                    </a>
                                    <a className={item.itemTypeId === 50 && props.jobInstalled ? "" : "hidden"} href="#" onClick={(e) => openFencingStock(e, index)}>
                                        <span className={"fa-solid fa-circle-plus edit--icon alignIconCenter tooltipitem tooltipitem__right" + (props.jobInstalled && item.fencingStock.panels < 1 ? " makeitred" : "") }><span className="tooltipitemtext tooltipitemtext__right">Add Fencing Stock</span></span>
                                    </a>
                                </td>
                                <td className={props.showBracing ? "table__text--align" : "hidden"}>
                                    <select className={item.itemTypeId === 51 ? "select table__select--size" : "hidden"} id="fenceBraceId" name="fenceBraceId" value={item.fenceBraceId} onChange={(e) => handleBraceChange(e, index)} disabled={item.itemTypeId != 51} >
                                        <option hidden defaultValue="-1"></option>
                                        <option value={1}>Brace Every Panel</option>
                                        <option value={2}>Brace Every 2nd Panel</option>
                                        <option value={3}>Brace Every 3rd Panel</option>
                                        <option value={4}>Brace Custom</option>
                                    </select>
                                </td>
                                <td className={props.jobTypeId === 3 || props.showEpaItems
                                    ? "hidden" : "table__text--align"}>
                                    <input type='text' maxLength={100} className="input allocate__qtySize" id="unitNumber" name="unitNumber" value={item.unitNumber} onChange={(e) => handleCellChangeText(e, index)} />
                                </td>
                                <td className={props.showTruck ? "table__text--align" : "hidden"}>
                                    <select className="select" id="truck" name="truck" value={item.truck} onChange={(e) => handleCellChange(e, index)}>
                                        <option hidden defaultValue="-1"></option>
                                        {props.truckOptions.map(truck =>
                                            <option key={truck.id} value={truck.id}>{truck.name}</option>
                                        )};
                                    </select>
                                </td>
                                <td className={props.jobTypeId === 3 || !props.showTruck ? "hidden" : "table__text--align"}>
                                    <select className="select" id="truckDoors" name="truckDoors" value={item.truckDoors} onChange={(e) => handleCellChange(e, index)}>
                                        <option hidden defaultValue="-1"></option>
                                        {props.truckSideOptions.map(ts =>
                                            <option key={ts.id} value={ts.id}>{ts.name}</option>
                                        )};
                                    </select>
                                </td>
                                <td className={props.jobTypeId === 3 ? "hidden" : "table__text--align"}>
                                    <input type='date' min={minDate} className="input allocate__dateSize" id="scheduleDate" name="scheduleDate" value={item.scheduleDate} onChange={(e) => handleScheduleDateChange(e, index)} />
                                </td>
                                <td className={props.jobTypeId === 3 || (!props.isJobEvent && !props.schedulePickup) ? "hidden" : "table__text--align"}>
                                    <input type='date' min={minDate} className={item.installOnly ? "hidden" : "input allocate__dateSize"} id="pickupDate" name="pickupDate" value={item.pickupDate} onChange={(e) => handleCellDateChange(e, index)} />
                                </td>
                                <td className="table__text--align">
                                    <input type='number' min="0" step="1" className={item.customHirePeriod ? "input allocate__size100 textalignright" : "hidden"} id="hirePeriod" name="hirePeriod" value={item.hirePeriod} onChange={(e) => handleCellChange(e, index)} disabled={item.itemTypeId === 26} />
                                    <select className={item.customHirePeriod ? "hidden" : "select table__select--size"} id="hirePeriod" name="hirePeriod" value={item.hirePeriod} onChange={(e) => handleCellChange(e, index)} disabled={item.itemTypeId === 8 || item.itemTypeId === 22 || item.itemTypeId === 26 || item.itemTypeId === 44 || item.itemTypeId === 45 || item.itemTypeId === 47 || item.itemTypeId === 52 || item.itemTypeId === 54 || (item.itemTypeId >= 58 && item.itemTypeId <= 61) } >
                                        <option hidden defaultValue="-1"></option>
                                        <option hidden={item.defaultHirePeriod > 1} value={1}>1 Day</option>
                                        <option hidden={item.defaultHirePeriod > 7 || item.invoicePeriodTypeId === 2} value={7}>1 Week</option>
                                        <option hidden={item.defaultHirePeriod > 14 || item.itemTypeId === 25 || item.itemTypeId === 46 || item.invoicePeriodTypeId === 2} value={14}>2 Weeks</option>
                                        <option hidden={item.defaultHirePeriod > 21 || item.itemTypeId === 25 || item.itemTypeId === 46 || item.invoicePeriodTypeId === 2} value={21}>3 Weeks</option>
                                        <option hidden={item.defaultHirePeriod > 28 || item.itemTypeId === 25 || item.itemTypeId === 46 || item.invoicePeriodTypeId === 2} value={28}>4 Weeks</option>
                                        <option hidden={item.defaultHirePeriod > 35 || item.itemTypeId === 25 || item.itemTypeId === 46 || item.invoicePeriodTypeId === 2} value={35}>5 Weeks</option>
                                        <option hidden={item.itemTypeId === 19 || item.itemTypeId === 23 || item.defaultHirePeriod > 42 || item.invoicePeriodTypeId === 2} value={42}>6 Weeks</option>
                                        <option hidden={item.itemTypeId === 23 || item.itemTypeId === 25 || item.itemTypeId == 26 || item.itemTypeId === 46 || item.defaultHirePeriod > 56 || item.invoicePeriodTypeId === 2} value={56}>8 Weeks</option>
                                        <option hidden={item.itemTypeId === 19 || item.itemTypeId === 23 || item.defaultHirePeriod > 70 || item.invoicePeriodTypeId === 2} value={70}>10 Weeks</option>
                                        <option hidden={item.invoicePeriodTypeId === 2 || (item.defaultHirePeriod > 91 && item.itemTypeId != 19 && item.itemTypeId != 27 && item.itemTypeId != 28)} value={91}>13 Weeks</option>
                                        <option hidden={item.itemTypeId === 23 || item.invoicePeriodTypeId === 2 || item.defaultHirePeriod > 98} value={98}>14 Weeks</option>
                                        <option hidden={item.itemTypeId === 23 || item.invoicePeriodTypeId === 2 || item.defaultHirePeriod > 112} value={112}>16 Weeks</option>
                                        <option hidden={item.itemTypeId != 25 || item.invoicePeriodTypeId === 2} value={140}>20 Weeks</option>
                                        <option value={item.invoicePeriodTypeId === 2 ? 6 : 182}>{item.invoicePeriodTypeId === 2 ? "6 Months" : "26 Weeks"}</option>
                                        <option hidden={item.itemTypeId != 23} value={252}>36 Weeks</option>
                                        <option hidden={item.itemTypeId != 25} value={280}>40 Weeks</option>
                                        <option value={item.invoicePeriodTypeId === 2 ? 12 : 364}>{item.invoicePeriodTypeId === 2 ? "12 Months" : "52 Weeks"}</option>
                                    </select>
                                </td>
                                <td className="table__text--align">
                                    <div className={item.customHirePeriod || item.itemId < 1 || item.hirePeriod === 1 ? "hidden" : "tooltipitem tooltipitem__right"}><i className="fa-solid fa-pen-to-square" onClick={(e) => editCustomHirePeriod(e, index)}></i>
                                        <span className="tooltipitemtext tooltipitemtext__right">Enter Hire Period in {item.invoicePeriodTypeId === 2 ? "Months" : "Weeks"}</span>
                                    </div>
                                </td>
                                <td className={props.showMaintenance ? "table__text--align" : "hidden"}>
                                    <select className={!item.item.toLowerCase().includes("sewer connect") && (item.itemTypeId === 25 || item.itemTypeId === 26 || (item.productGroupId === 6 && item.itemTypeId != 61)) ? "select" : "hidden"} id="frequencyId" name="frequencyId" value={item.frequencyId} onChange={(e) => handleCellChange(e, index)}>
                                        <option defaultValue="-1"></option>
                                        {props.frequencyOptions.map(freq =>
                                            <option key={freq.id} hidden={(item.itemTypeId === 59 && (freq.id < 4 || freq.id > 8)) || (item.itemTypeId === 58 && freq.id < 9) || (item.itemTypeId === 60 && freq.id > 3) } value={freq.id}>{freq.name}</option>
                                        )};
                                    </select>
                                </td>
                                <td className={props.showEpaItems ? "table__text--align" : "hidden"}>
                                    <input type='number' min="0" step="1" className='input allocate__qtySize textalignright' id="size" name="size" value={item.size} onChange={(e) => handleCellChange(e, index)} />
                                </td>
                                <td className={props.showEpaItems ? "table__text--align" : "hidden"}>
                                    <input type='number' min="0" step="1" className={item.itemTypeId === 61 ? "input allocate__qtySize textalignright" : "hidden"} id="hours" name="hours" value={item.hours} onChange={(e) => handleCellHoursChange(e, index)} />
                                </td>
                                <td className="table__text--align">
                                    <input type='number' min="0" step="1" className='input allocate__qtySize textalignright' id="quantity" name="quantity" value={item.quantity} onChange={(e) => handleCellChange(e, index)} disabled={item.item.includes("Septic") && item.itemTypeId === 58} />
                                </td>
                                <td className="table__text--align">
                                    {item.unitOfMeasure}
                                </td>
                                <td className={props.jobTypeId === 3 ? "hidden" : "table__text--align"}>
                                    <input type='text' maxLength={25} className="input table-input--minwidth table-input--maxwidthsm" id="purchaseOrderNumber" name="purchaseOrderNumber" value={item.purchaseOrderNumber} onChange={(e) => handleCellChangeText(e, index)} />
                                </td>
                                <td className={props.jobTypeId === 3 || !props.chargeFuelSurchargeSwitchedOn || !props.customerNewFuelInvoice ? "hidden" : "table__text--align"}>
                                    <input type='text' maxLength={25} className="input table-input--minwidth table-input--maxwidthsm" id="purchaseOrderNumberFuel" name="purchaseOrderNumberFuel" value={item.purchaseOrderNumberFuel} onChange={(e) => handleCellChangeText(e, index)} />
                                </td>
                                <td className="table__text--align">
                                    <input type='number' min="0" step="0.01" className='input textalignright allocate__size100' id="initialHire" name="initialHire" value={item.initialHire} onChange={(e) => handleCellPriceChange(e, index)} />
                                </td>
                                <td className={props.showEpaItems ? "table__text--align" : "hidden"}>
                                    <input type='number' min="0" step="0.01" className={item.itemTypeId === 61 ? 'input textalignright allocate__size100' : "hidden"} id="trench" name="trench" value={item.trench} onChange={(e) => handleCellPriceChange(e, index)} />
                                </td>
                                <td className={props.showEpaItems ? "table__text--align" : "hidden"}>
                                    <input type='number' min="0" step="0.01" className={item.itemTypeId === 61 ? 'input textalignright allocate__size100' : "hidden"} id="confinedSpace" name="confinedSpace" value={item.confinedSpace} onChange={(e) => handleCellPriceChange(e, index)} />
                                </td>
                                <td className={props.showCleaning ? "table__text--align" : "hidden"}>
                                    <input type='number' min="0" step="0.01" className='input textalignright allocate__size100' id="cleaning" name="cleaning" value={item.cleaning} onChange={(e) => handleCellPriceChange(e, index)} />
                                </td>
                                <td className="table__text--align">
                                    <input type='number' min="0" step="0.01" className='input textalignright allocate__size100' id="travel" name="travel" value={item.travel} onChange={(e) => handleCellPriceChange(e, index)} />
                                </td>
                                <td className="table__text--align">
                                    <input type='number' min="0" step="0.01" className='input textalignright allocate__size100' id="fuelSurcharge" name="fuelSurcharge" value={item.fuelSurcharge} onChange={(e) => handleCellPriceChange(e, index)} />
                                </td>
                                <td className="table__text--align">
                                    <input type='number' min="0" step="0.01" className='input textalignright  table-input--minwidth table-input--maxwidthsm' id="amount" name="amount" value={item.amount} onChange={(e) => handleCellAmountChange(e, index)} />
                                </td>
                                <td className={props.showAdditionalHire ? "table__text--align" : "hidden"}>
                                    <input type='number' min="0" step="0.01" className='input textalignright  table-input--minwidth table-input--maxwidthsm' id="overhireRate" name="overhireRate" value={item.overhireRate} onChange={(e) => handleCellChange(e, index)} />
                                </td>
                                <td className="table__text--align">
                                    <a className={!item.notes ? "hidden" : ""} data-toggle="modal" data-target="#notesModal" href="#" onClick={(e) => editNotes(e, index)}>
                                        <div className="tooltipitem tooltipitem__left">{item.notes ? item.notes.substring(0, 20) + "... " : ""}
                                            <span className="tooltipitemtext tooltipitemtext__left">{item.notes}</span>
                                        </div>
                                    </a>
                                    <a className={!item.notes && lastRowIndex != index ? "" : "hidden"} data-toggle="modal" data-target="#notesModal" href="#" onClick={(e) => editNotes(e, index)}>
                                        <span className="fas fa-pencil-alt edit--icon alignIconCenter"></span>
                                    </a>
                                </td>
                                <td className="table__text--align">
                                    {lastRowIndex != index ?
                                        <div className="delete--tablecell">
                                            <a className="makeitred" href="#" onClick={(e) => deleteItem(e, item.itemIndex)}>
                                                <span className="fas fa-times-circle edit--icon alignIconCenter"></span>
                                            </a>
                                        </div> : ""
                                    }
                                </td>
                            </tr>
                        </tbody>
                    )}
                </table>
            </div>
        </div>
    )

}

export default NewJobPricelistToiletData;